import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { PrecheckinStep1Repository } from '../repository/precheckin-step1.repository';

export class UpdatePrecheckinUseCase implements UseCase<any, boolean> {
    constructor(private readonly repository: PrecheckinStep1Repository) {}

    execute(data: any): Observable<boolean> {
        return this.repository.updatePrecheckin(data);
    }
}
